export enum IconSize {
	Regular = 'regular',
	Small = 'small',
	Large = 'large',
	Xlarge = 'xlarge',
}

export enum IconVariation {
	Filled = 'filled',
}
